export const BLOCK_LEGAL_TEXT_TEST_IDS = {
    EXPAND_BUTTON: 'block-legal-text-expand-button',
};
